<script>

export default {
  name: 'GiftcardDonationComponent',
  props: {
    disclaimer: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <section class="container-static">
    <div
      v-if="disclaimer"
      id="disclaimer"
      class="giftcard-donation__disclaimer"
      data-ui="gift-card-donation-information"
      v-html="disclaimer"
    />
  </section>
</template>
